import React, { Component } from "react";
import Address from "./Address";
import History from "./History";
import Downloads from "./Downloads";
import Verf from "./Verf";
import { inject, observer } from "mobx-react";

@inject("AdminStore")
@observer
class Account extends Component {
  static defaultProps = {
    defaultTab: "address"
  };

  state = {
    activeTab: this.props.defaultTab
  };

  componentDidMount() {
    if (this.props.admin) {
      this.props.AdminStore.getUserProfile(this.props.match.params.id);
    }
  }

  render() {
    return (
      <div className="main-content">
        <div className="section-title standalone">
          <p>MY ACCOUNT</p>
          <div className="sep" />
        </div>

        <div className="acc-tabs">
          <p
            className={this.state.activeTab === "address" ? "active" : null}
            onClick={() => this.setState({ activeTab: "address" })}
            style={{ width: !this.props.admin ? "33.33%" : "50%"}}
          >
            Account Info
          </p>
          <p
            className={this.state.activeTab === "history" ? "active" : null}
            onClick={() => this.setState({ activeTab: "history" })}
            style={{ width: !this.props.admin ? "33.33%" : "50%"}}
          >
            Order History
          </p>
          {!this.props.admin ? (
            <p
              className={this.state.activeTab === "downloads" ? "active" : null}
              onClick={() => this.setState({ activeTab: "downloads" })}
            >
              My Downloads
            </p>
          ) : null}
          {!this.props.admin ? (
            <p
              className={this.state.activeTab === "verf" ? "active" : null}
              onClick={() => this.setState({ activeTab: "verf" })}
            >
              Verification Images
            </p>
          ) : null}
        </div>

        {this.state.activeTab === "address" ? (
          <Address admin={this.props.admin} />
        ) : this.state.activeTab === "history" ? (
          <History admin={this.props.admin} />
        ) : this.state.activeTab === "verf" ? (
          <Verf admin={this.props.admin} />
        ) : this.state.activeTab === "downloads" ? (
          <Downloads admin={this.props.admin} />
        ) : (
          <Address admin={this.props.admin} />
        )}
      </div>
    );
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/components/Account.js